<template>
  <div class="py-3">
    <CardComponent @onClose="$emit('onClose')">
      <div class="px-5 py-3">
        <div class="flex justify-between items-center">
          <p class="text-sm font-bold text-greenPrimary">Detail Dipesan</p>
          <SearchInput id="dipesan" @input="search" />
        </div>

        <div
          class="overflow-x-auto relative rounded-lg pt-3"
          v-if="!detailDipesan.loading"
        >
          <table class="w-full text-sm text-left text-gray-500 mb-3">
            <thead>
              <tr class="bg-gray-200">
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  #
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 border border-gray-300 text-center"
                >
                  Feature Id
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Kode Petak
                </th>
                <th
                  scope="row"
                  class="py-3 px-1 text-center border border-gray-300"
                >
                  Total Order
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Tanggal Order
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="bg-white"
                v-for="(item, index) in detailDipesan.rows"
                :key="index"
              >
                <td
                  class="py-2 px-3 border border-gray-300 text-center"
                  valign="top"
                >
                  {{ (page - 1) * limit + (index + 1) }}
                </td>
                <td class="py-2 px-3 border border-gray-300" valign="top">
                  {{ item.feature_id }}
                </td>
                <td
                  class="py-2 px-3 border border-gray-300 text-right"
                  valign="top"
                >
                  {{ item.kode_petak }}
                </td>
                <td
                  class="py-2 px-1 border border-gray-300 text-center"
                  valign="top"
                >
                  {{ item.total_order }}
                </td>
                <td class="py-2 px-3 border border-gray-300">
                  <div class="grid grid-cols-5 gap-2">
                    <div
                      class="flex"
                      v-for="(value, key) in item.order_by_date"
                      :key="key"
                    >
                      <span
                        class="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-blue-900 dark:text-blue-300"
                      >
                        {{ key }} : {{ value }}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <PaginationComponent
            v-model:length="length"
            v-model:size="limit"
            v-model:page="page"
            @onSelectChange="changePage"
          />
        </div>

        <LoadingLottie v-if="detailDipesan.loading" />
      </div>
    </CardComponent>
  </div>
</template>
<script>
import CardComponent from "@/components/CardWithCloseButton.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import SearchInput from "@/components/SearchInput.vue";
import { useDashboardStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";

export default {
  components: {
    CardComponent,
    PaginationComponent,
    LoadingLottie,
    SearchInput,
  },
  setup() {
    const dashboardStore = useDashboardStore();
    const { detailDipesan } = storeToRefs(dashboardStore);

    const limit = ref(25);
    const offset = ref(0);
    const length = ref(0);
    const page = ref(1);
    const q = ref(null);

    const getDetail = async () => {
      await dashboardStore.getDetailDipesan({});
      length.value = detailDipesan.value.count;
    };

    onMounted(() => {
      getDetail();
    });

    const changePage = async (value) => {
      page.value = value;
      offset.value = (page.value - 1) * limit.value;
      let dataparams = { offset: offset.value };

      if (q.value != null || q.value != "") {
        dataparams = { ...dataparams, q: q.value };
      }
      await dashboardStore.getDetailDipesan(dataparams);
      length.value = detailDipesan.value.count;
    };

    const search = async (event) => {
      offset.value = 0;
      page.value = 1;
      q.value = event.target.value;

      await dashboardStore.getDetailDipesan({
        offset: offset.value,
        q: event.target.value,
      });
      length.value = detailDipesan.value.count;
    };

    return {
      detailDipesan,
      limit,
      page,
      length,
      changePage,
      search,
    };
  },
};
</script>
<style></style>
